import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.5 17.6H3.83333C3.36662 17.6 3.13327 17.6 2.95501 17.5091C2.79821 17.4293 2.67072 17.3018 2.59083 17.145C2.5 16.9667 2.5 16.7334 2.5 16.2666V2.59998M16.6667 6.76664L13.4009 10.2522C13.2772 10.3843 13.2153 10.4503 13.1406 10.4845C13.0747 10.5146 13.0021 10.527 12.93 10.5205C12.8482 10.5132 12.7679 10.4715 12.6072 10.388L9.89277 8.97858C9.73212 8.89516 9.65179 8.85346 9.57003 8.84609C9.49787 8.83959 9.42526 8.85201 9.35936 8.88215C9.28471 8.91628 9.22282 8.98233 9.09906 9.11443L5.83333 12.6",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }